PJQ.views.projects.ProjectMessaging = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Messages'),
        selectedContacts: [],
        selectedContactGroups: [],
        selectedProjectMessageContactBroadcasts: [],
        filter: {
            status: [],
            groups: [],
            isPrintOrder: false,
            isDownloaded: false,
            isVisited: false,
            isSelected: false,
            isDelivered: false,
            isOpened: false,
            vendorSector: '',
            laborStatus: [],
            minorityStatus: []
        },
        hasCompanyLevelCustomFields: false,
        hasContactLevelCustomFields: false
    },
    events: {
        'keyup .input-pm-search': 'searchChanged',
        'click .btn-pm-search': 'search',
        'click .project-messages-filter': 'filterDialog',
        'click .project-messages-clear-filter': 'clearFilterClick',
        'click .btn-project-message-settings': 'settings',
        'change .project-message-enable-declined': 'enableDeclinedChanged',
        'click .btn-add-participants-from-project': 'addParticipantsFromProject',
        'click .btn-quick-add': 'quickAdd',
        'click .btn-add-participant-new': 'addNewContact',
        'click .btn-detailed-search': 'detailedSearch',
        'click .btn-detailed-search-new': 'detailedSearch',
        'click .btn-simple-search': 'simpleSearch',
        'click .btn-quick-search': 'quickSearch',
        'click .project-message-delete-contacts': 'deleteParticipantsFromProject',
        'click .btn-send-message': 'sendMessage',
        'click .btn-message-template-send': 'sendMessage',
        'click .project-message-set-responses': 'setResponses',
        'click .project-message-order-prints': 'orderPrints',
        'click .export-view': 'exportView',
        'click .manage-bid-packages': 'manageBidPackages',
        'click .import-bid-packages': 'importBidPackages',
        'click .btn-radius-package-add': 'addByBidPackageRadius',
        'click .filter-unsent': 'filterUnsent'
    },
    renderData: function () {
        return {
            project: this.options.project,
            showGroupCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY),
            showGroupContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT),
            showCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY),
            showContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT),
            showBidPackagesView: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES)
        };
    },
    afterRender: function () {
        this.clearFilter(false);
        this.options.selectedContacts = [];
        this.options.selectedContactGroups = [];
        this.options.isTradesViewSelectAll = false;
        this.updateContactStats();

        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISABLE_QUICKADD))
            this.$('.btn-quick-add').hide();

        this.options.isTradesViewSelectAll = false;
        this.options.settings = new PJQ.models.projectParticipants.ProjectMessageViewSettings();
        this.options.bidFormSettings = new PJQ.models.bidForms.Settings();
        PJQ.app.session.project.fetchBidFormSettings(_.bind(function(bidFormSettings) {
            this.options.bidFormSettings = bidFormSettings;
            this.options.canViewBidAmount = !this.options.bidFormSettings.get('isSealBids') || this.options.bidFormSettings.isSealedBidContact(PJQ.app.session.user.get('id'));
            this.options.settings.fetch({
                success: _.bind(function () {
                    // scan to make sure we haven't deleted a column that is referenced by groupBy or orderBy
                    _.each(this.options.settings.get('settings'), _.bind(function (setting) {
                        if (_.size(setting.columns) === 0) {
                            if (setting.columnsDefault.indexOf(setting.orderBy) === -1) {
                                setting.orderBy = setting.columnsDefault[0];
                            }
                        } else if (setting.columns.indexOf(setting.orderBy) === -1) {
                            setting.orderBy = setting.columns[0];
                        }
                    }, this));

                    let defaultView = this.options.viewProjectMessageId ? 'messagecontact' : this.options.settings.get('defaultView');
                    this.viewSelectPicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.project-message-view'),
                        defaultValue: defaultView,
                        onChange: _.bind(function (value) {

                            let callback = _.bind(function () {
                                this.options.selectedContacts = [];
                                this.options.selectedContactGroups = [];
                                this.options.isTradesViewSelectAll = false;
                                this.clearFilter(false, false);
                                this.renderContactStats();
                                this.renderView(value);
                            }, this);

                            if (_.size(this.options.selectedContacts) === 0)
                                callback();
                            else {
                                new PJQ.views.modals.YesNo({
                                    header: "Selected Participants",
                                    body: "Selected participants will be cleared when switching views.  Do you want to continue?",
                                    onYes: _.bind(function () {
                                        callback();
                                    }, this),
                                    onNo: _.bind(function () {
                                        this.viewSelectPicker.setValue(this.currentView);
                                    }, this)
                                });
                            }
                        }, this)
                    });

                    this.renderView(defaultView);

                    if (this.options.copyProjectMessageId) {
                        this.copyProjectMessage(this.options.copyProjectMessageId);
                        this.options.copyProjectMessageId = null;
                    }

                }, this)
            });
        } , this));

    },
    getSearchFor: function() {
        let searchFor = this.$('.input-pm-search').val().trim();

        if (searchFor.length <= 15 && PJQ.helpers.formatHelpers.numbersOnly(searchFor).length == 10)
            searchFor = PJQ.helpers.formatHelpers.numbersOnly(searchFor);

        return searchFor;
    },
    getViewData: function (view, callback, overrides) {
        let searchFor = this.getSearchFor(),
            statusFilter = [...this.options.filter.status],
            groupIdList = this.options.filter.groups.join(',');


        if (overrides) {
            if (overrides.isPerGroup)
                statusFilter.push('PER_GROUP');
        }

        if (this.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.filter.publicPrivate)
            statusFilter.push(this.options.filter.publicPrivate);

        _.each(this.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        let viewSettings = this.options.settings.getSettings(view),
            filterCustomField = null,
            filterCustomFieldValue = null;
        if (searchFor.indexOf("::") !== -1 && (view === PJQ.constants.projectMessaging.views.CONT || view === PJQ.constants.projectMessaging.views.COMP)) {
            let filterData = searchFor.split('::'),
                filterCustomFieldName = filterData[0].trim();

            filterCustomFieldValue = filterData[1].trim();

            if (_.size(filterCustomFieldName) > 0 && _.size(filterCustomFieldValue) > 0) {
                filterCustomField = _.find(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    return customField.get('fieldName').toLowerCase() === filterCustomFieldName.toLowerCase();
                }, this));
                if (filterCustomField == null) {
                    filterCustomField = _.find(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                        return customField.get('fieldName').toLowerCase() === filterCustomFieldName.toLowerCase();
                    }, this));
                }

                if (filterCustomField != null) {
                    searchFor = "";
                }
            }
        }

        let data = new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: this.options.project,
            view: view,
            searchFor: searchFor,
            statusFilter: statusFilter.join(','),
            groupIdList: groupIdList,
            withCustomFields: viewSettings.hasCustomFields
        });

        if (_.size(PJQ.helpers.urlHelpers.buildApiUrl(data.endpoint(), {})) > 2000) {
            new PJQ.views.BaseModal({
                header: "Filter Error",
                body: "The total size of the filter requested is too large.   Please reduce the number of filter options, or the amount of text being searched for.",
                onOk: _.bind(function() {
                    callback({ models: [] });
                }, this)
            });
        }
        else {
            data.fetch({
                success: _.bind(function () {
                    if (this.options.filter.isSelected) {
                        data.reset(_.filter(data.models, _.bind(function (row) {
                            return this.options.selectedContacts.indexOf(row.get('contactId')) !== -1;
                        }, this)));
                    }

                    if (filterCustomField != null) {
                        let filterCfValueLower = filterCustomFieldValue.toLowerCase(),
                            filterCustomFieldChoiceIds = _.map(_.filter(filterCustomField.choices.models, function (cfChoice) {
                                return cfChoice.get('choiceName').trim().toLowerCase().indexOf(filterCfValueLower) !== -1;
                            }), function (cfChoice) {
                                return cfChoice.id;
                            });
                        data.reset(_.filter(data.models, _.bind(function (row) {
                            let checkCf = function (cf) {
                                let result = false;
                                if (cf.id === filterCustomField.id && cf.value != null) {
                                    if (filterCustomField.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE) {
                                        result = typeof cf.value.indexOf === 'function' && _.size(_.intersection(cf.value, filterCustomFieldChoiceIds)) > 0;
                                    } else {
                                        result = cf.value != null && cf.value.toString().trim().toLowerCase().indexOf(filterCfValueLower) !== -1;
                                    }
                                }
                                return result;
                            };
                            return null != _.find(row.get('companyCustomFieldValues'), checkCf) || null != _.find(row.get('contactCustomFieldValues'), checkCf);
                        }, this)));
                    }

                    callback(data);
                }, this)
            });
        }
    },
    renderView: function (view) {
        if (view != null) {
            this.currentView = view;
        }

        // set response option only valid while NOT in Messages view
        if (this.currentView === PJQ.constants.projectMessaging.views.MSGCONT) {
            this.$('.project-message-set-responses').css('display', 'none');
        } else {
            this.$('.project-message-set-responses').css('display', '');
        }

        let loader = new PJQ.Loader(this.$el);
        this.getViewData(this.currentView, _.bind(function (data) {
            if (loader)
                loader.remove();
            loader = null;
            this.renderViewData(this.currentView, data.models);
        }, this));
    },
    renderViewData: function (view, data) {
        if (this.dataTable)
            this.dataTable.cleanup();

        let dataTableOptions = {
            el: this.$('.project-message-grid'),
            data: data,
            view: view,
            projectMessagingView: this,
            userSettings: this.options.settings,
            settings: this.options.settings.getSettings(view),
            afterDataTableRender: _.bind(function (dataTable) {
                if (dataTable) {
                    this.$('.datatable-paging-copy').empty();
                    this.$('.dataTables_paginate', dataTable.el).first().appendTo(this.$('.datatable-paging-copy'));
                }
            }, this)
        };

        this.$('.filter-unsent').prop('disabled', (this.currentView === 'messagecontact') || this.$('.count-unsent-contacts').html() === '0');

        this.dataTable = this.getDataTableInstance(dataTableOptions);
    },
    getDataTableInstance: function (options) {
        let dataTable = null;
        switch (options.view) {
            case PJQ.constants.projectMessaging.views.GROUPCOMP:
            case PJQ.constants.projectMessaging.views.GROUPCONT:
                dataTable = new PJQ.views.projects.ProjectMessagingTradesDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
            case PJQ.constants.projectMessaging.views.COMP:
                dataTable = new PJQ.views.projects.ProjectMessagingCompanyDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
            case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
            case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
            case PJQ.constants.projectMessaging.views.MSGCONT_CONT:
            case PJQ.constants.projectMessaging.views.COMP_CONT:
            case PJQ.constants.projectMessaging.views.CONT:
            case PJQ.constants.projectMessaging.views.BIDPKGS_CONT:
                dataTable = new PJQ.views.projects.ProjectMessagingContactDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.MSGCONT:
                dataTable = new PJQ.views.projects.ProjectMessagingMessagesDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.RSPCONT:
                options.order = [];
                dataTable = new PJQ.views.projects.ProjectMessagingResponsesDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.BIDPKGS:
                dataTable = new PJQ.views.projects.ProjectMessagingBidPackagesDataTable(options);
                break;
        }

        return dataTable;
    },
    manageBidPackages: function () {
        new PJQ.views.bidPackages.ManageBidPackagesModal({
            project: PJQ.app.session.project,
            onClose: _.bind(function () {
                this.renderView(this.dataTable.options.view);
            }, this)
        });
    },
    importBidPackages: function () {
        new PJQ.views.bidPackages.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (submittals) {
                this.renderView(this.dataTable.options.view);
            }, this)
        });
    },
    updateContactStats: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'participants'
            },
            {
                endpoint: 'stats'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint
        }).get().done(_.bind(function (data) {
            this.stats = data;
            this.renderContactStats();
        }, this));
    },
    renderContactStats: function () {
        this.$('.count-total-contacts').html(this.stats.totalCount.toString());
        this.$('.count-selected-contacts').html(_.size(this.options.selectedContacts));
        this.$('.count-unsent-contacts').html(this.stats.unsentCount ? this.stats.unsentCount.toString() : "0");
        this.$('.participant-stats').removeClass('hidden');
        let $buttons = this.$('.project-message-sel-part-header,.project-message-set-responses,.project-message-delete-contacts,.project-message-order-prints,.project-message-resend-messages');
        if (_.size(this.options.selectedContacts) > 0) {
            $buttons.removeClass('hidden');
        } else {
            $buttons.addClass('hidden');
        }

        this.$('.filter-unsent').prop('disabled', (this.currentView === 'messagecontact') || this.stats.unsentCount === 0);
    },
    addByBidPackageRadius: function () {
        new PJQ.views.bidPackages.BidPackageRadiusModal({
            project: this.options.project,
            onSave: _.bind(function (contacts) {
                if (_.size(contacts) > 0) {
                    this.addSelectedContacts(contacts);
                    this.stats.unsentCount += _.size(contacts);
                    this.renderContactStats();
                    this.renderView();
                }
            }, this)
        });
    },
    addSelectedContacts: function (contactIds) {
        this.options.selectedContacts = _.uniq(_.union(contactIds, this.options.selectedContacts));
        this.renderContactStats();
    },
    removeSelectedContacts: function (contactIds) {
        _.each(contactIds, _.bind(function (contactId) {
            this.options.selectedContacts = _.filter(this.options.selectedContacts, function (contact) {
                return contact !== contactId;
            });
        }, this));
        this.renderContactStats();
    },
    clearSelectedContacts: function () {
        this.options.selectedContacts = [];
        this.$('.trade-select-all-contacts, .select-all-contacts, .select-all-companies, .select-company, .select-contact').prop('checked', false);
        this.renderContactStats();
    },
    addSelectedContactGroups: function (contactGroups) {
        this.options.selectedContactGroups = _.uniq(_.union(contactGroups, this.options.selectedContactGroups), false, function (x) {
            return x.contactId + '|' + x.groupId;
        });
    },
    removeSelectedContactGroups: function (contactGroups) {
        _.each(contactGroups, _.bind(function (contactGroup) {
            this.options.selectedContactGroups = _.filter(this.options.selectedContactGroups, function (selectedContactGroup) {
                return !(selectedContactGroup.contactId === contactGroup.contactId && selectedContactGroup.groupId === contactGroup.groupId);
            });
        }, this));
    },
    isContactSelected: function (contactId) {
        return this.options.selectedContacts.indexOf(contactId) !== -1;
    },
    enableDeclinedChanged: function () {
        // enable or disable all select-company and select-contact whose rows have a Disabled status.
        // process the Parent view
        this.enableDeclinedHelper(this.dataTable, this.isEnableDeclined());
    },
    enableDeclinedHelper: function (dataTable, isEnableDeclined) {

        // process each row of this view
        dataTable.dataTable.rows().invalidate().draw();

        // process each child view of this view recursively

    },
    isEnableDeclined: function () {
        return this.$('.project-message-enable-declined').prop('checked');
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function () {
        this.renderView(this.dataTable.options.view);
    },
    filterDialog: function () {
        let filterInfo = new PJQ.models.projectParticipants.FilterInfo(null, {
            project: this.options.project,
            view: this.dataTable.options.view.toLowerCase(),
            searchFor: this.getSearchFor()
        });
        filterInfo.fetch({
            success: _.bind(function () {
                new PJQ.views.projects.FilterProjectParticipantsModal({
                    filterInfo: filterInfo,
                    filter: this.options.filter,
                    projectMessagingView: this,
                    onFilter: _.bind(function () {
                        this.renderView(this.dataTable.options.view);
                    }, this)
                });
            }, this)
        });
    },
    clearFilterClick: function () {
        if (this.options.selectedContacts.length > 0) {
            new PJQ.views.modals.YesNo({
                header: "Participants Selected",
                body: "Clearing the filter will also clear selected contacts.  Do you still want to continue?",
                onYes: _.bind(function () {
                    this.options.selectedContacts = [];
                    this.options.selectedContactGroups = [];
                    this.options.selectedProjectMessageContactBroadcasts = [];
                    this.renderContactStats();
                    this.clearFilter();
                }, this)
            });
        } else
            this.clearFilter();
    },
    clearFilter: function (refresh = true, clearSearch = true) {
        if (clearSearch)
            this.$('.input-pm-search').val('');

        this.$('.select-all-companies, .select-all-contacts, .trade-select-all-contacts').prop('checked', false);
        this.options.isTradesViewSelectAll = false;
        this.options.filter = {
            status: [],
            groups: [],
            isPrintOrder: false,
            isDownloaded: false,
            isVisited: false,
            isSelected: false,
            isDelivered: false,
            isOpened: false,
            vendorSector: '',
            publicPrivate: '',
            laborStatus: [],
            minorityStatus: []
        };

        if (refresh)
            this.renderView(this.dataTable.options.view);
    },
    filterUnsent: function() {
        this.clearFilter(false);
        this.options.filter.status = ['UNSENT'];
        this.renderView(this.dataTable.options.view);
    },
    settings: function () {
        new PJQ.views.projects.ProjectMessagingSettingsModal({
            projectMessagingView: this,
            onSave: _.bind(function () {
                this.renderView(this.dataTable.options.view);
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    deleteContacts: function (contacts, isRemoveFromAB) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'contacts'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                contacts: contacts,
                isRemoveFromAB: isRemoveFromAB
            }
        }).delete().done(_.bind(function () {
            this.removeSelectedContacts(contacts);
            this.updateContactStats();
            PJQ.notifications.notify.successNotify({
                message: 'Contact' + (contacts.length > 1 ? 's' : '') + ' removed successfully.'
            });
            this.renderView();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    deleteContactGroups: function (contactGroups, isRemoveFromAB) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'contactgroups'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                contactGroups: contactGroups,
                isRemoveFromAB: isRemoveFromAB
            }
        }).delete().done(_.bind(function () {
            this.options.selectedContacts = [];
            this.options.selectedContactGroups = [];
            this.updateContactStats();
            PJQ.notifications.notify.successNotify({
                message: 'Contact(s) removed successfully.'
            });
            this.renderView();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    deleteParticipantsFromProject: function () {
        let removeFrom = _.size(this.options.selectedContactGroups) > 0 ? 'selected trades' : 'project';

        if (_.size(this.options.selectedContacts) === 0 && _.size(this.options.selectedContactGroups) === 0) {
            new PJQ.views.BaseModal({
                header: "No Participants Selected",
                body: "Please select one or more participants before using this feature."
            });
            return;
        }

        new PJQ.views.projects.DeleteProjectParticipants({
            title: "Remove Participant" + (_.size(this.options.selectedContacts) > 1 ? 's' : ''),
            body: "Are you sure you want to remove the selected participant" + (_.size(this.options.selectedContacts) > 1 ? 's' : '') + " from the " + removeFrom + '?',
            onDelete: _.bind(function (isRemoveFromAB) {
                if (_.size(this.options.selectedContactGroups) > 0)
                    this.deleteContactGroups(this.options.selectedContactGroups, isRemoveFromAB);
                else
                    this.deleteContacts(this.options.selectedContacts, isRemoveFromAB);
            }, this)
        });
    },
    sendMessage: function (sender, contacts) {
        let defaultTemplateKey = null;
        if (sender && $(sender.currentTarget).data('templateKey')) {
            defaultTemplateKey = $(sender.currentTarget).data('templateKey');
        }
        PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function () {
            let replyToContacts = [], fnContinue = _.bind(function () {
                this.inviteModal = new PJQ.views.projectInvites.ProjectInviteModal({
                    project: PJQ.app.session.project,
                    emailTemplates: PJQ.app.session.emailTemplates.projectMessage.models,
                    projectMessagingView: this,
                    replyToContacts: replyToContacts,
                    defaultTemplateKey: defaultTemplateKey,
                    onSend: _.bind(function () {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            $('.send-message-templates').show();
                            $('.btn-send-message').hide();
                        }
                        this.$('.send-message-label').html('New Message');
                        this.options.project.set('isOnline', true);
                        this.options.selectedContacts = [];
                        this.options.selectedContactGroups = [];
                        this.options.selectedProjectMessageContactBroadcasts = [];
                        this.options.projectMessageSettings = null;
                        PJQ.app.session.project.inviteSettings = null;
                        this.renderContactStats();
                        this.renderView();
                    }, this),
                    onAddFromThisProject: _.bind(function (inviteSettings) {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            $('.send-message-templates').hide();
                            $('.btn-send-message').show();
                        }
                        $('div.project-messages span.send-message-label').html('Resume Message');
                    }, this),
                    onViewSelected: _.bind(function (inviteSettings) {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            $('.send-message-templates').hide();
                            $('.btn-send-message').show();
                        }
                        $('div.project-messages span.send-message-label').html('Resume Message');
                        this.viewSelectPicker.setValue(PJQ.constants.projectMessaging.views.CONT);
                        this.options.filter = {
                            status: [],
                            groups: [],
                            isPrintOrder: false,
                            isDownloaded: false,
                            isVisited: false,
                            isSelected: true,
                            vendorSector: '',
                            publicPrivate: '',
                            laborStatus: [],
                            minorityStatus: []
                        };
                        this.renderView(PJQ.constants.projectMessaging.views.CONT);
                    }, this),
                    onCancel: _.bind(function () {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            this.$('.send-message-templates').show();
                            this.$('.btn-send-message').hide();
                        }
                        $('div.project-messages span.send-message-label').html('New Message');
                        PJQ.app.session.project.inviteSettings = null;
                    }, this),
                    isShowQuickAdd: !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISABLE_QUICKADD),
                    isShowAttachments: true
                });
            }, this);

            if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_ENABLE_REPLYTO_OVERRIDE)) {
                if (PJQ.app.session.project.get('user'))
                    replyToContacts.push(PJQ.app.session.project.get('user'));

                if (PJQ.app.session.project.get('user2') && _.size(_.filter(replyToContacts, function (user) {
                    return user.id == PJQ.app.session.project.get('user2').id
                })) == 0)
                    replyToContacts.push(PJQ.app.session.project.get('user2'));

                PJQ.app.session.project.fetchProjectContacts(_.bind(function () {
                    _.each(PJQ.app.session.project.projectContacts.models, _.bind(function (projectContact) {
                        if (projectContact.get('id') < 0 && _.size(_.filter(replyToContacts, function (user) {
                            return user.id == projectContact.get('id')
                        })) == 0) {
                            replyToContacts.push(projectContact.attributes);
                        }
                    }, this));
                    fnContinue();
                }, this));
            } else {
                fnContinue();
            }
        }, this));

        if (contacts != null) {
            this.inviteModal.addSelectedContacts(contacts);
        }
    },
    quickAdd: function () {
        new PJQ.views.projects.QuickAddParticipantsModal({
            project: this.options.project,
            onSave: _.bind(function (contact) {
                this.addSelectedContacts([contact.id]);
                this.stats.unsentCount++;
                this.renderContactStats();
                this.renderView();
            }, this)
        });
    },
    addNewContact: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectParticipants.ProjectParticipant({
                projectId: PJQ.app.session.project.id,
                masterUserId: PJQ.app.session.get('masterUserId'),
                isForceSaveExistingEmail: false,
                country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
            }),
            showNotes: true,
            showActive: true,
            deleteLabel: 'Remove from Project',
            onSave: _.bind(function (model, isNew) {
                this.addSelectedContacts([model.get('contactId')]);
                this.stats.unsentCount++;
                this.stats.totalCount++;
                this.renderContactStats();
                this.renderView();
            }, this)
        });
    },
    detailedSearch: function (e) {
        $('form[name="modal-add-participants"]').remove();
        let options = {
            onSave: _.bind(function (selectedContacts) {
                this.addSelectedContacts(selectedContacts);
                this.stats.unsentCount += _.size(selectedContacts);
                this.renderContactStats();
                this.renderView();
            }, this)
        };

        if ($(e.currentTarget).hasClass('btn-detailed-search-new') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
            options.isWrapForm = false;
            options.wrapFormName = null;
            options.isUseNewAddressBook = true;
        }

        new PJQ.views.projects.AddParticipantsDetailedModal(options);
    },
    simpleSearch: function () {
        let showUnionStatus = true;
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
            showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
        }
        new PJQ.views.projectParticipants.AddParticipantsModal({
            model: this.options.project,
            isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
            isUnionStatusEnabled: showUnionStatus,
            isReturnContactIds: true,
            onSave: _.bind(function (selectedContacts, sendMessage = false) {
                if (sendMessage && _.size(selectedContacts) > 0) {
                    this.sendMessage(null, selectedContacts);
                } else {
                    this.addSelectedContacts(selectedContacts);
                    this.stats.unsentCount += _.size(selectedContacts);
                    this.renderContactStats();
                    this.renderView();
                }
            }, this)
        });
    },
    quickSearch: function () {
        new PJQ.views.contacts.SelectContactsModal({
            disableBlacklisted: true,
            disableBadEmail: true,
            isSingleChoice: false,
            onSave: _.bind(function (selectedContacts) {
                if (_.size(selectedContacts) === 0) {
                    PJQ.notifications.notify.successNotify({
                        message: 'No participants were added'
                    });
                    return;
                }

                this.options.project.addParticipantsById(selectedContacts, _.bind(function () {
                    this.addSelectedContacts(_.map(selectedContacts, function (selectedContact) {
                        return selectedContact.get('contactId');
                    }));
                    this.stats.unsentCount += _.size(selectedContacts);
                    this.renderContactStats();
                    this.renderView();
                }, this));
            }, this)
        });
    },
    addParticipantsFromProject: function () {
        let statuses = this.options.project.getProjectStatusList();
        statuses.unshift(['PENDING', true]);
        new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
            model: this.options.project,
            isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
            projectResponses: statuses,
            isReturnContactIds: true,
            onSave: _.bind(function (selectedContacts) {
                this.addSelectedContacts(selectedContacts);
                this.stats.unsentCount += _.size(selectedContacts);
                this.renderContactStats();
                this.renderView();
            }, this)
        });
    },
    copyProjectMessage: function (projectMessageId) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'projectmessages',
                value: projectMessageId
            },
            {
                endpoint: 'copy'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
        }).get().done(_.bind(function (data) {
            data.messageType = data.templateKey;
            data.privateFolders = new PJQ.collections.files.Files(data.privateFolders);
            data.attachments = new PJQ.collections.files.Files(data.attachments);
            data.responseDue = data.responseDue ? PJQ.helpers.dateHelpers.getDateString(new Date(data.responseDue), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD) : '';
            PJQ.app.session.project.inviteSettings = data;
            this.sendMessage();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong.'
            });
        });

    },
    deleteProjectMessage: function (projectMessageId, callback) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'projectmessages',
                value: projectMessageId
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint
        }).delete().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Message deleted successfully.'
            });
            if (typeof callback === 'function')
                callback();

        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    orderPrints: function () {
        let callback = _.bind(function () {
            let contacts = new PJQ.collections.contacts.ContactInfoList(null, {
                contactIds: this.options.selectedContacts
            });
            contacts.fetch({
                success: _.bind(function () {
                    new PJQ.views.files.OrderPrintsModal({
                        recipients: contacts.models,
                        onOrderPlaced: _.bind(function () {
                            this.clearSelectedContacts();
                        }, this)
                    });
                }, this)
            });
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();

    },
    setResponses: function () {
        if (_.size(this.options.selectedContacts) === 0) {
            new PJQ.views.BaseModal({
                header: "No Participants Selected",
                body: "Please select one or more participants before using this feature."
            });
            return;
        }

        let statuses = this.options.project.getProjectStatusList();
        statuses.unshift(['PENDING', true]);
        new PJQ.views.projects.SetProjectParticipantsStatusModal({
            projectResponses: statuses,
            projectMessagingView: this,
            onSave: _.bind(function (status, companyComment, contactComment) {
                let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.options.project.id
                    },
                    {
                        endpoint: 'participants'
                    },
                    {
                        endpoint: 'status'
                    }
                ]);

                let loader = new PJQ.Loader(this.$el);
                new PJQ.ajax.Request({
                    endpoint: endpoint,
                    data: {
                        ids: this.options.selectedContacts,
                        status: status,
                        companyComment: companyComment,
                        contactComment: contactComment
                    }
                }).post().done(_.bind(function () {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Contact' + (this.options.selectedContacts.length > 1 ? 's' : '') + ' updated successfully.'
                    });
                    this.renderView();
                }, this)).fail(function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Something went wrong!'
                    });
                });
            }, this)
        });
    },
    exportView: function () {
        let statusFilter = [...this.options.filter.status];

        if (this.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.filter.publicPrivate)
            statusFilter.push(this.options.filter.publicPrivate);

        _.each(this.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        statusFilter = statusFilter.join(',');

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'participants'
            },
            {
                endpoint: 'views',
                value: this.currentView
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'statusFilter',
                value: statusFilter
            },
            {
                parameter: 'groupIdList',
                value: this.options.filter.groups.join(',')
            },
            {
                parameter: 'searchFor',
                value: this.getSearchFor()
            },
            {
                parameter: 'withCustomFields',
                value: true
            }
        ]));

    }
});

// Modals
PJQ.views.projects.GradeProjectContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Grade-Project-Contact'),
        width: '300px',
        onGrade: _.noop,
        row: null
    },
    events: {
        'click button.grade': 'gradeChanged',
        'click button.clear-grade': 'onClear'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        this.renderData = {
            companyName: this.options.row.data().get('companyName')
        };
    },
    afterRender: function () {
        if (this.options.row.data().get('grade') > 0)
            this.$('button[data-stars="1"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 1)
            this.$('button[data-stars="2"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 2)
            this.$('button[data-stars="3"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 3)
            this.$('button[data-stars="4"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 4)
            this.$('button[data-stars="5"] i').removeClass('text-muted').addClass('text-gold');
    },
    gradeChanged: function (e) {
        this.options.row.data().set('grade', parseInt(this.$(e.currentTarget).data('stars')));
        this.$('button.grade').removeClass('text-gold').addClass('text-muted');
        this.afterRender();
        this.onGrade();
    },
    onGrade: function () {
        if (typeof this.options.onGrade === 'function')
            this.options.onGrade(this.options.row.data().get('grade'));
        this.removeModal();
    },
    onClear: function () {
        this.$('button.grade').removeClass('text-gold').addClass('text-muted');
        this.options.row.data().set('grade', 0);
        this.onGrade();
    }
});

PJQ.views.projects.ProjectParticipantCommentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Participant-Comment'),
        minWidth: '400px',
        onComment: _.noop,
        project: null,
        comments: [],
        participant: null,
        isCompanyComments: false
    },
    events: {
        'keyup .project-contact-comment': 'commentChanged',
        'click .project-contact-comment-save': 'commentAdded',
        'click .project-comment-delete': 'commentDeleted'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        this.renderData = {
            companyName: this.options.participant.attributes.companyName,
            contactName: this.options.participant.attributes.contactName,
            comments: this.options.comments
        };
    },
    afterRender: function () {
    },
    commentDeleted: function (sender) {
        this.selectedCard = this.$(sender.currentTarget).closest('div.card');
        new PJQ.views.BaseModal({
            header: "Delete Comment",
            body: "Are you sure you want to delete this comment?",
            isShowCancelButton: true,
            onOk: _.bind(function () {
                let comment = new PJQ.models.projectParticipants.ProjectContactComment(null, {
                        project: this.options.project,
                        contactId: this.options.isCompanyComments ? this.options.participant.attributes.contactCompanyId : this.options.participant.attributes.contactId
                    }),
                    projectContactCommentId = parseInt(this.selectedCard.data('projectContactCommentId')),
                    parentContainer = this.selectedCard.parent(),
                    isLastCard = this.selectedCard.hasClass('last-comment');

                this.selectedCard.remove();

                // if no comments left, return the 'empty comment' comment back to the caller
                if ($('div.card', parentContainer).length === 0) {
                    comment.set('comment', 'No Comments Added');
                    if (typeof this.options.onComment === 'function')
                        this.options.onComment(comment);

                    this.$('.comments-header, .comments-list').hide();

                } else if (isLastCard) {
                    // if this was the newest comment, return the next newest comment back to the caller and mark the next newest comment
                    comment.set('comment', this.$('div.card').last().find('.comment-body').text().trim());

                    if (typeof this.options.onComment === 'function')
                        this.options.onComment(comment);

                    this.$('div.card').last().addClass('last-comment');
                }

                comment.set('projectContactCommentId', projectContactCommentId);
                comment.destroy();
            }, this)
        });

    },
    commentChanged: function () {
        this.$('.project-contact-comment-save').prop('disabled', _.size(this.$('.project-contact-comment').val()) === 0);
    },
    commentAdded: function () {
        this.onComment();
    },
    onComment: function () {
        let comment = new PJQ.models.projectParticipants.ProjectContactComment(null, {
            project: this.options.project,
            contactId: this.options.isCompanyComments ? this.options.participant.attributes.contactCompanyId : this.options.participant.attributes.contactId,
            isCompanyComments: this.options.isCompanyComments
        });
        comment.set('comment', this.$('.project-contact-comment').val());
        comment.save(null, {
            success: _.bind(function () {
                if (typeof this.options.onComment === 'function')
                    this.options.onComment(comment);
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.FilterProjectParticipantsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Filter-Project-Participants'),
        width: '650px',
        filterInfo: null,
        filter: null,
        onFilter: _.noop
    },
    events: {
        'click button.filter': 'filter'
    },
    beforeModalCreated: function () {
        this.options.fieldSettingsEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
        if (this.options.fieldSettingsEnabled && this.coreFieldSettings == null) {
            PJQ.app.session.fetchContactFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                this.coreFieldSettings = settings;
                this.render();
            }, this));
        }
    },
    beforeRender: function () {
        this.renderData = {
            filterInfo: this.options.filterInfo,
            filter: this.options.filter,
            view: this.options.projectMessagingView.dataTable.options.view,
            checkFieldVisible: _.bind(this.checkFieldVisible, this)
        };
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let result;
            switch (fieldName) {
                case 'sector':
                    result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
                    break;
                case 'laborStatus':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
                    break;
                case 'classifications':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false;
                    break;
                default:
                    result = true;
            }
            return result;
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisibleContact') || fieldSettings.get('isVisibleAdmin');
            }
        }
        return true;
    },
    afterRender: function () {
        _.each(this.options.filter.status, _.bind(function (status) {
            this.$('input.filter-status[data-status="' + status + '"]').prop('checked', true);
        }, this));

        this.$('input.filter-print-order').prop('checked', this.options.filter.isPrintOrder);
        this.$('input.filter-download').prop('checked', this.options.filter.isDownloaded);
        this.$('input.filter-visited').prop('checked', this.options.filter.isVisited);
        this.$('input.filter-selected').prop('checked', this.options.filter.isSelected);
        this.$('input.filter-delivered').prop('checked', this.options.filter.isDelivered);
        this.$('input.filter-opened').prop('checked', this.options.filter.isOpened);

        this.sectorSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-sector'),
            defaultValue: this.options.filter.vendorSector
        });

        this.publicPrivateSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-public-private'),
            defaultValue: this.options.filter.publicPrivate
        });

        this.laborStatusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-labor-status'),
            isMultiple: true,
            noneSelectedText: 'All Labor Statuses',
            defaultValue: this.options.filter.laborStatus
        });

        this.minorityStatusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-minority-status'),
            isMultiple: true,
            noneSelectedText: 'All Certifications',
            defaultValue: this.options.filter.minorityStatus
        });

        this.groupSelector = new PJQ.views.groups.GroupSelector({
            el: this.$('.filter-groups'),
            isShowNoGroup: true,
            isShowGroupCount: true,
            groups: this.options.filterInfo.get('groups'),
            selectedGroupIds: this.options.filter.groups,
            onGroupSelected: _.bind(function () {
                //this.selectedGroups = this.groupSelector.getGroupsData().new;
            }, this)
        });

    },
    filter: function () {

        this.options.projectMessagingView.options.filter.status = [];

        _.each(this.$('input.filter-status'), _.bind(function (input) {
            if ($(input).prop('checked'))
                this.options.projectMessagingView.options.filter.status.push($(input).data('status'));
        }, this));

        this.options.projectMessagingView.options.filter.isPrintOrder = this.$('input.filter-print-order').prop('checked');
        this.options.projectMessagingView.options.filter.isDownloaded = this.$('input.filter-download').prop('checked');
        this.options.projectMessagingView.options.filter.isVisited = this.$('input.filter-visited').prop('checked');
        this.options.projectMessagingView.options.filter.isDelivered = this.$('input.filter-delivered').prop('checked');
        this.options.projectMessagingView.options.filter.isOpened = this.$('input.filter-opened').prop('checked');
        this.options.projectMessagingView.options.filter.isSelected = this.$('input.filter-selected').prop('checked');
        this.options.projectMessagingView.options.filter.vendorSector = this.$('select.filter-sector').val();
        this.options.projectMessagingView.options.filter.publicPrivate = this.publicPrivateSelectPicker.getValue();
        this.options.projectMessagingView.options.filter.laborStatus = this.laborStatusSelectPicker.getValue();
        this.options.projectMessagingView.options.filter.minorityStatus = this.minorityStatusSelectPicker.getValue();

        this.options.projectMessagingView.options.filter.groups = [];

        let groupsData = this.groupSelector.getGroupsData();
        _.each(groupsData.selected, _.bind(function (group) {
            this.options.projectMessagingView.options.filter.groups.push(group.id);
        }, this));

        if (typeof this.options.onFilter === 'function')
            this.options.onFilter();

        this.removeModal();
    }
});

PJQ.views.projects.ProjectMessagingSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Messaging-Settings'),
        width: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        // copy settings for our UI; we only update global settings object on save.
        this.options.settings = [];
        this.options.defaultView = this.options.projectMessagingView.options.settings.get('defaultView');
        _.each(this.options.projectMessagingView.options.settings.attributes.settings, _.bind(function (setting) {
            let dbInstance = this.options.projectMessagingView.getDataTableInstance({
                    view: setting.view,
                    settings: this.options.projectMessagingView.options.settings.getSettings(setting.view)
                }),
                columns = [];
            if (dbInstance != null) {
                columns = dbInstance.getColumns(true);
            }
            selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));


            this.options.settings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });

        }, this));

        this.renderData = {
            showGroupCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY),
            showGroupContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT),
            showCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY),
            showContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT),
            showBidPackagesView: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES)
        };
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.projectMessagingView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)

        });

        this.selectView(this.options.projectMessagingView.dataTable.options.view);
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.settings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.$('div.rows-per-page').show();
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
        } else
            this.$('div.rows-per-page').hide();

        if (view === PJQ.constants.projectMessaging.views.GROUPCOMP || view === PJQ.constants.projectMessaging.views.GROUPCONT || view === PJQ.constants.projectMessaging.views.MSGCONT || view === PJQ.constants.projectMessaging.views.RSPCONT || view === PJQ.constants.projectMessaging.views.BIDPKGS)
            this.$('div.select-columns').hide();
        else {
            this.$('div.select-columns').show();

            if (this.dataTable) {
                this.dataTable.undelegateEvents();
                $(this.dataTable.el).empty();
            }

            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$('div.select-columns-datatable'),
                data: this.currentView.columns,
                isHideSearch: true,
                order: [],
                columns: [
                    {"data": "title", "title": "Column", "orderable": false},
                    {
                        "data": "visible",
                        "title": "Show",
                        "orderable": false,
                        "searchable": false,
                        "render": _.bind(function (data) {
                            return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                        }, this),
                        "width": '10%'
                    }
                ],
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'

            });
        }
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        //update global settings from local
        this.options.projectMessagingView.options.settings.set('defaultView', this.options.defaultView);

        _.each(this.options.settings, _.bind(function (settingTemp) {
            _.each(this.options.projectMessagingView.options.settings.get('settings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        } else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        //save settings to database
        this.options.projectMessagingView.options.settings.save(null, {
            success: _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave();

                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.ManageProjectParticipantTradesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Participant-Trades'),
        minWidth: '900px',
        onSave: _.noop
    },
    events: {
        'click .manage-trades-save': 'onSave',
        'change .select-trade': 'tradeSelectChanged',
        'change .select-all-trades': 'tradeSelectAllChanged'
    },
    beforeRender: function () {
        this.renderData = {};
    },
    afterRender: function () {
        this.groups = new PJQ.collections.projectParticipants.ProjectParticipantGroups(null, {
            contactId: this.options.contactId
        });

        this.groups.fetch({
            success: _.bind(function () {
                this.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$('.project-participant-trades'),
                    pageLength: 999999,
                    isHideSearch: true,
                    data: this.groups.models,
                    dom: 't',
                    order: [],
                    columns: [
                        {
                            "data": "attributes.isSelected",
                            "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-trades" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>',
                            "orderable": false,
                            "searchable": false,
                            "render": _.bind(function (data) {
                                return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-trade"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                            }, this),
                            "width": '10%'
                        },
                        {
                            "data": "attributes.groupName",
                            "title": "Trade",
                            "orderable": false
                        }
                    ]
                });
            }, this)
        });
    },
    tradeSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow(tr);

        row.data().set('isSelected', $(e.currentTarget).prop('checked'));
    },
    tradeSelectAllChanged: function (e) {
        _.each(this.$el.find('input.select-trade'), _.bind(function (input) {
            let tr = $(input).closest('tr'),
                row = this.dataTable.getRow(tr);

            row.data().set('isSelected', $(e.currentTarget).prop('checked'));
            $(input).prop('checked', $(e.currentTarget).prop('checked'));
        }, this));

    },
    onSave: function () {
        this.groups.save({
            success: _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.groups);

                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.SetProjectParticipantsStatusModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Set-Project-Participants-Status'),
        minWidth: '500px',
        onSave: _.noop,
        projectResponses: [],
        projectMessagingView: null
    },
    events: {
        'click .set-responses': 'onSave',
        'click .comment-type>div': 'commentTypeClicked'
    },
    beforeRender: function () {
        this.renderData = {
            projectResponses: this.options.projectResponses
        };
    },
    afterRender: function () {

        let isContactComment = false;
        _.each(this.options.projectMessagingView.options.settings.get('settings'), _.bind(function (setting) {
            _.each(setting.columns, _.bind(function (column) {
                if (column === 'commentsContact')
                    isContactComment = true;
            }, this));
        }, this));

        if (isContactComment)
            this.$('.comment-type>div[data-filter="contact-comment"]').click();

        this.projectStatus = new PJQ.inputs.Selectpicker({
            el: this.$('.project-status'),
            defaultValue: this.options.projectResponses[0][0]
        });
    },
    commentTypeClicked: function (e) {
        let $target = $(e.currentTarget),
            filter = $target.data('filter');
        this.$('.comment-type>div').removeClass('selected');
        $target.addClass('selected');

        this.$('.comments>textarea').hide();
        this.$('.' + $target.data('filter')).show();
    },
    onSave: function () {
        new PJQ.views.modals.YesNo({
            header: "Set Status",
            body: "Are you sure you want to set the Project Status for " + _.size(this.options.projectMessagingView.options.selectedContacts) + " participants?",
            onYes: _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.projectStatus.getValue(), this.$('.company-comment').val(), this.$('.contact-comment').val());

                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.DeleteProjectParticipants = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Delete-Project-Participants'),
        minWidth: '500px',
        onDelete: _.noop,
        title: '',
        body: ''
    },
    events: {
        'click .btn-remove': 'onDelete'
    },
    beforeModalCreated: function () {
        this.canDeleteContact = PJQ.app.session.hasPermission('contacts.canDelete');
    },
    renderData: function () {
        return {
            title: this.options.title,
            body: this.options.body,
            canDeleteContact: this.canDeleteContact
        };
    },
    onDelete: function () {
        if (typeof this.options.onDelete === 'function')
            this.options.onDelete(this.canDeleteContact && this.$('.delete-ab').prop('checked'));

        this.removeModal();
    }
});
